'use client';

import { Box, Container, Grid } from '@mui/material';

import { TableSkeleton } from '@/components/skeletons/common';
import { ProfitLossCardSkeleton } from './ProfitLossCardSkeleton';
import { TraderProfileCardSkeleton } from './TraderProfileCardSkeleton';

export const LeaderboardPortfolioSkeleton = () => {
  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} lg={6}>
            <TraderProfileCardSkeleton />
          </Grid>
          <Grid item xs={12} lg={6}>
            <ProfitLossCardSkeleton />
          </Grid>
        </Grid>

        <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
          <Box sx={{ width: 100, height: 40, bgcolor: 'action.hover', borderRadius: 2 }} />
          <Box sx={{ width: 100, height: 40, bgcolor: 'action.hover', borderRadius: 2 }} />
          <Box sx={{ width: 100, height: 40, bgcolor: 'action.hover', borderRadius: 2 }} />
        </Box>

        <TableSkeleton rows={8} columns={5} />
      </Container>
    </Box>
  );
};

export default LeaderboardPortfolioSkeleton;
